export const setSchoolLocations = 'SET_SCHOOL_LOCATIONS';
export const SET_SCHOOL_INSTANCE = 'SET_SCHOOL_INSTANCE';

export function setSchool(school) {
    return {
        type: SET_SCHOOL_INSTANCE,
        data: school
    };
}